import { ComponentPropsWithoutRef } from 'react';

interface Props extends ComponentPropsWithoutRef<'svg'> {
  readonly size: number;
}

export default function ThinCrossIcon(props: Props) {
  return (
    <svg
      width={props.size}
      height={props.size}
      {...props}
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m7.2 0 .8.8L4.8 4 8 7.2l-.8.8L4 4.8.8 8 0 7.2 3.2 4 0 .8.8 0 4 3.2 7.2 0Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
